import React from "react";
import themeLarge from "../../ThemeLarge";

class ProjectSortYearMobile extends React.Component {
  constructor(props) {
    super(props);
    const currentYear = new Date().getFullYear();
    this.labels = [
      "All",
      currentYear,
      currentYear - 1,
      currentYear - 2,
      "Older",
    ];
    this.state = {
      activeLabel: "All",
    };
  }

  handleClick = (label) => {
    this.setState({ activeLabel: label });

    // Send selected label to parent
    if (this.props.onFilterChange) {
      this.props.onFilterChange(label);
    }
  };

  render() {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          marginBottom: "10px",
        }}
      >
        <p
          style={{
            fontSize: themeLarge.fontSize.small,
            paddingLeft: "10px",
            paddingRight: "5px",
            marginBottom: "0",
          }}
        >
          Sort by
        </p>

        <div>
          <select
            className="form-select"
            style={{
              fontSize: themeLarge.fontSize.small,
              borderRadius: "15px",
              padding: "5px 30px",
              fontFamily: "Kumbh Sans",
              backgroundColor: themeLarge.colors.bg,
              color: themeLarge.colors.text,
              borderColor: themeLarge.colors.primary,
            }}
            value={this.state.activeLabel}
            onChange={(e) => this.handleClick(e.target.value)}
          >
            {this.labels.map((label) => (
              <option key={label} value={label}>
                {label}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }
}

export default ProjectSortYearMobile;
